<template>
  <div class="hello">
    <a href="#cx_letra_video"
       data-toggle="collapse"
       data-parent="#accordion"
       aria-expanded="true" aria-controls="cx_letra_video"
       id="fecharplayer" class="btn-fechar"><i class="fas fa-times"></i></a>


    <div id="scrollletra">
      <pre> {{ letter }}</pre>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScrollComponent',
    props: ['letter'],
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    mounted() {

      $(document).ready(function(){
        $("#fecharplayer").click(function () {
         $("#arrow").removeClass('btns_letra_video')
         $("#arrow").removeClass('collapsed')
          $("#arrow").addClass("btns_letra_video  collapsed")
        });

      });

      $('#scrollletra').mCustomScrollbar({
        axis: 'y',
        theme: 'light-3',
        advanced: {
          autoExpandHorizontalScroll: true,
          updateOnContentResize: true,
          updateOnImageLoad: true,
          autoUpdateTimeout: 10,
          updateOnSelectorChange: "ul li"
        },
        live: true
      });
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #scrollletra {
    min-width: 260px;
    max-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/jqueryplugin/ScrollComponent.vue